import React from 'react';
import DateFormat from 'constants/date_format';
import IndexTableBodyCell from '../../../../shared/index/table/body_cell';

export const AverageScoreCell = ({ averageScore }) => (
  <IndexTableBodyCell size="s" name="average-score" hideBelowMD center>
    {averageScore ? `${parseInt(averageScore, 10)}%` : '-'}
  </IndexTableBodyCell>
);

export const RecentActivityCell = ({ recentActivity }) => (
  <IndexTableBodyCell size="s" name="recent-activity" hideBelowMD center>
    {recentActivity
      ? moment(recentActivity).format(DateFormat.MONTH_DAY_YEAR_SHORT)
      : 'N/A'}
  </IndexTableBodyCell>
);

export const LastCompletedCell = ({ lastCompleted }) => {
  const date = lastCompleted ? moment(lastCompleted) : null;
  return (
    <IndexTableBodyCell
      size="s"
      name="last-completed"
      title={date ? date.format(DateFormat.MONTH_DAY_YEAR_SHORT) : null}
      hideBelowMD
      center
    >
      {date ? date.fromNow() : '-'}
    </IndexTableBodyCell>
  );
};
